<template>
  <div :class="[customPadding, { 'tw-container': !expand }]">
    <div :class="contentClass">
      <div
        v-if="$slots.category || description || title || $slots.detail"
        :class="customMargin"
        class="tw-text-center tw-mb-5 sm:tw-mb-11"
      >
        <div v-if="$slots.category" class="tw-mb-2">
          <slot name="category" />
        </div>
        <h1 v-if="title" class="tw-text-mb-title-1 lg:tw-text-dt-title-1">
          {{ title }}
        </h1>
        <p
          v-if="description"
          class="tw-text-dark-gray tw-text-mb-body-small lg:tw-text-dt-body tw-mb-3"
        >
          {{ description }}
        </p>
        <div v-if="titleUnderline" class="tw-flex tw-justify-center tw-mt-2">
          <div class="tw-w-11 tw-h-1 tw-bg-secondary" />
        </div>
        <div v-if="$slots.detail">
          <slot name="detail" />
        </div>
      </div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string;
  description?: string;
  titleUnderline?: boolean;
  expand?: boolean;
  customPadding?: string;
  contentClass?: string;
  customMargin?: string;
}>();
</script>
